export default __webpack_public_path__ + "static/media/45k.6c30ca28.md";